import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionsFactory('log-viewer')
  .factory()

export {
  Provider as LogViewerProvider,
  useStore as useLogViewerStore,
}
